import React from 'react'
import {useSelector} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#fff',
  },
  barColorPrimary: {
    backgroundColor: '#2e7d32',
  },
})(LinearProgress);

export default () => {
  const visible = useSelector(state => state.loader.visible);
  return (
    <div className='loader'>
      {visible && <ColorLinearProgress />}
    </div>
  );
};